const Select = {
  variants: {
    filled: {
      field: {
        bg: 'gray.700',
        boxShadow: '0px 4px 7px -1px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px',
        color: 'white',
        _focus: {
          bg: 'gray.700',
        },
        _hover: {
          bg: 'gray.700',
        },
        'option, optgroup': {
          bg: 'gray.700',
          color: 'white'
        }
      },
    },
  },
  defaultProps: {
    variant: 'filled',
  },
};

export default Select;
